export default "__VITE_ASSET__r$o$gK50__"